import client from "./client";

const getSettlements = () => client.get("/subsidiary/dashboard/settlement/paginated?page=4&limit=100");
const getSettlementTransactions = (query) => client.get(`/subsidiary/dashboard/settlement/transactions/summary?${query}`);

export default { getSettlements, getSettlementTransactions };
